import VerifyBankAccount from '@/components/bank-account/verify/index';

export default VerifyBankAccount;
